var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.formData.id ? "编辑角色" : "新增角色",
        visible: _vm._dialogVisible,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm._dialogVisible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "el-form",
        { ref: "listForm", attrs: { model: _vm.formData } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "角色名称",
                "label-width": "120px",
                prop: "roleName",
                rules: [
                  {
                    required: true,
                    message: "请输入角色名称",
                    trigger: "blur",
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { maxlength: 30 },
                model: {
                  value: _vm.formData.roleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "roleName", $$v)
                  },
                  expression: "formData.roleName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", "label-width": "120px" } },
            [
              _c("el-input", {
                staticClass: "remark-wrapper",
                attrs: {
                  type: "textarea",
                  rows: 2,
                  maxlength: 200,
                  placeholder: "请输入备注",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.formData.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "remark", $$v)
                  },
                  expression: "formData.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm._dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.btnLoading,
                size: "small",
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }